import { Card, SkeletonBox, DescriptionList } from '@circlefin/components'
import { useDate } from '@circlefin/hooks'
import { MaybeNull } from '@shared/components/common'
import { GraphQLErrorBoundary } from '@shared/components/errors'
import { useUserQuery } from '@shared/graphql'
import useTranslation from 'next-translate/useTranslation'

const { Label, Description } = DescriptionList

export const UserInfoList = () => {
  const { date } = useDate()
  const { t } = useTranslation('settings')
  const { data, loading, error, refetch } = useUserQuery({
    notifyOnNetworkStatusChange: true,
  })

  return (
    <Card>
      <Card.Content className="pb-8 pl-8 pt-5">
        <GraphQLErrorBoundary error={error} retry={refetch}>
          <DescriptionList density="loose">
            <Label className="w-76">{t('personalInfo.name')}</Label>
            <Description data-testid="user-info-name">
              <SkeletonBox className="block h-5 w-36" loading={loading}>
                <MaybeNull>{data?.user.name}</MaybeNull>
              </SkeletonBox>
            </Description>
            <Label className="w-76">{t('personalInfo.role')}</Label>
            <Description className="flex flex-col" data-testid="user-info-role">
              <>
                <SkeletonBox className="block h-5 w-20" loading={loading}>
                  <MaybeNull>
                    {data?.user.permissionGroup != null &&
                      t(`personalInfo.roleType.${data.user.permissionGroup}`)}
                  </MaybeNull>
                </SkeletonBox>
                <SkeletonBox className="mt-2 block h-3 w-40" loading={loading}>
                  <p className="text-black-300 font-circular-regular">
                    <MaybeNull>
                      {data?.user.created != null &&
                        t('personalInfo.statusDescription', {
                          date: date(data.user.created),
                        })}
                    </MaybeNull>
                  </p>
                </SkeletonBox>
              </>
            </Description>
            <Label className="w-76">{t('personalInfo.email')}</Label>
            <Description data-testid="user-info-email">
              <SkeletonBox className="block h-5 w-48" loading={loading}>
                <MaybeNull>{data?.user.email}</MaybeNull>
              </SkeletonBox>
            </Description>
          </DescriptionList>
        </GraphQLErrorBoundary>
      </Card.Content>
    </Card>
  )
}
